<template>
  <v-dialog v-model="showDialog" persistent max-width="400">
    <v-card class="py-3 px-1">
      <v-card-title>
        <div class="text-h2 font-weight-bold mx-auto">
          Deseja apagar esse documento?
        </div></v-card-title
      >
      <v-card-actions>
        <div class="mx-auto">
          <v-btn color="primary" text @click="closeAndClean">Cancelar </v-btn>
          <v-btn color="pink darken-1" text @click="removeFile"
            >Apagar Documento</v-btn
          >
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { deletePhoto } from "../../../services/users.js";

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },

    closeView: {
      type: Function,
      required: true,
    },

    updateList: {
      type: Function,
      required: true,
    },

    photoData: {
      type: Object,
      required: true,
    },

    idPhoto: {
      type: String,
      default: "",
    },

    customer_id: {
      type: String,
      default: "",
    },
  },

  computed: {
    ...mapState("sales", ["lead", "user"]),
  },

  methods: {
    ...mapMutations("sales", ["setUser", "resetOtherState"]),

    closeAndClean() {
      this.closeView();
    },

    idPhotoDoc() {
      this.idPhoto();
    },

    async removeFile() {
      try {
        await deletePhoto(this.customer_id, this.idPhoto);
        this.updateList();
        this.closeView();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
